export default __webpack_public_path__ + "static/media/1.f7d5569c.jpg";